import { render, staticRenderFns } from "./DefaultOperations.vue?vue&type=template&id=4a2849db"
import script from "./DefaultOperations.vue?vue&type=script&setup=true&lang=ts"
export * from "./DefaultOperations.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports